<div class="govuk-width-container">
  <div class="d-flex">
      <a href="https://www.rbwm.gov.uk/" target="_blank" rel="noopener noreferrer" aria-label="Royal Borough of Windsor and Maidenhead (opens in new window)">
        <img src="assets/rbwm_logo_header_1.png" alt="RBWM logo" class="logo">
      </a>
      <gb-ui-header
          [imageDetail]="imageDetail"
          [showSearch]="true"
          [navLinks]="navigation"
          (searchTerm)="search($event)"
        >
      </gb-ui-header>
  </div>
</div>
